import {createSlice, createAsyncThunk, current} from "@reduxjs/toolkit";
import {instance, pathname} from "./ActionCreators";
import axios from "axios";
import { FilterParam } from 'utils/ticker-params-handler';
import {setPickedTickers} from './quotes';
import notifySuccess from 'utils/Notifications/Success';
import notifyError from 'utils/Notifications/Error';
import FilterHandler from 'utils/ticker-params-handler';

const _ = require("lodash");

export type SelectedFilterParamsState = {
    [key: string | number]: FilterParam[]
}

export interface IState {
    loading: boolean
    manual_query: {
        [key: string]: string
    }
    file_query: string
    error: null | string
    logic: LogicState
    query: string
    isQueryManual: boolean
    filterParams: FilterParam[]
    filterParamsOrder?: string[]
    selectedFilterParams: SelectedFilterParamsState
    params_filter_query?: string
    paramsList: {
        [key: string]: {
            value: string
            mark: string
        }
    },
    chosenParamsList: {
        [key: string]: {
            value: string
            mark: string
        }
    }
}

interface LogicState {
    [key: string | number] : '*' | '+'
}

const initialState: IState = {
    loading: false,
    manual_query: {},
    file_query: '',
    filterParams: [],
    selectedFilterParams: {},
    error: null,
    logic: {},
    query: '',
    isQueryManual: false,
    paramsList: {
        virt: {
            value: 'true',
            mark: 'B'
        },
        stopped: {
            value: 'true',
            mark: 'C'
        },
        close: {
            value: 'true',
            mark: 'D'
        },
        mm: {
            value: 'true',
            mark: 'E'
        },
        no_open: {
            value: 'true',
            mark: 'F'
        },
    },
    chosenParamsList: {}
}

export const filterSection = createAsyncThunk<any, { query: string, section_id: number | string }>('post/filter_workspace', async ({ query, section_id }, store) => {
    if (typeof query !== 'string' || !section_id) {
        return;
    }
    let response;
    const body = {
        query,
        section_id
    };
    try {
        response = await instance.post(pathname + 'api/filter_workspace', body);
    }
    catch(error) {
        console.error(error);
        notifyError('Некорректный фильтр');
        return;
    }
    notifySuccess('Фильтр применен');
    return response.data;
})

export const getTickerParams = createAsyncThunk('get/filter',
    async (_, store) => {
        const state = store.getState();
        //@ts-ignore
        if (!state.auth.loggedIn) {
            return;
        }
        const response = await instance.get(pathname + 'api/filter');
        //@ts-ignore
        if (!response && !(response && response.data)) {
            return;
        }
        store.dispatch(setFilterParams(response.data));
        FilterHandler.mnemonics = response.data.map(item => ({
            name: item.name,
            letter: item.formula_letter,
            type: item.type
        }));
        return response.data;
    }
)

export const setTickerParamsFilter = createAsyncThunk<any, { query: string, names: string[], id: string | number }>('set/filter',
    async ({ query, names, id }, store) => {
        const response = await instance.post(pathname + 'api/filter', {
            query,
            names
        });
        //@ts-ignore
        if (!response && !(response && response.data)) {
            return;
        }
        //store.dispatch(setParamsFilterQuery(response.data));
        store.dispatch(setPickedTickers({
            id,
            picked_tickers: response.data
        }));

        return response.data;
    }
)

export const sendFilteredColumns = createAsyncThunk<any, { columns: string[], id: number | string }>('patch/filter/cols', 
    async ({ columns, id }, store) => {
        const response = await instance.patch(pathname + 'api/workspace_config/' + id, { columns: [...columns.map(x => x === 'Close' ? 'Closed' : x)] });
        return response.data;
    }
)

const filterSlice = createSlice({
    name: 'filterSlice',
    initialState,
    reducers: {
        resetFilterQueries(state, action) {
            const { id } = action.payload;
            state.selectedFilterParams[id] = [];
            state.manual_query[id] = '';
            state.file_query = '';
        },
        addFilterQuery(state, action) {
            const {
                manual_query,
                caller
            } = action.payload;
            if (typeof manual_query === 'string') {
                state.manual_query[caller] = manual_query;
                return;
            }
        },
        removeFilterParam(state, action) {
            const { id, param } = action.payload;
            const _state = current(state.selectedFilterParams);
            const place = _state[id];
            if (Array.isArray(place)) {
                state.selectedFilterParams[id] = place.filter(_param => _param.name !== param.name);
            } 
        },
        setFilterParamsForWorkspace(state, action) {
            const { id, filters } = action.payload;
            if (id && Array.isArray(filters)) {
                state.selectedFilterParams[id] = filters;
            }
        },
        selectFilterParam(state, action) {
            const { id, param } = action.payload;
            if (typeof id === 'string' || typeof id === 'number') {
                const _state = current(state.selectedFilterParams);
                const place = _state[id];
                if (Array.isArray(place)) {
                    const existed = place.findIndex(x => x.name === param.name);
                    if (existed !== -1) {
                        let ex = place[existed];
                        state.selectedFilterParams[id][existed] = {
                            ...ex,
                            ...param
                        };
                        return;
                    }
                    state.selectedFilterParams[id].push(param);
                }
                else {
                    state.selectedFilterParams[id] = [param];
                }
            }
        },
        resetFilterState: () => initialState,
        setQueryFilter: (state, action) => {
            state.query = action.payload;
        },
        addQueryFilter: (state, action) => {
            const mark = action.payload
            const { logic } = state
            if (state.query === '') {
                state.query = mark
            } else {
                state.query = `${state.query}${logic}${mark}`
            }
        },
        setQueryToManual: (state, action) => {
            state.isQueryManual = action.payload
        },
        restoreFilter: (state) => {
            state.query = ''
        },
        setLogic: (state, action) => {
            const { id, value } = action.payload;
            state.logic[id] = value;
        },
        setFilterParams: (state, action) => {
            const sorted = action.payload.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
            state.filterParams = sorted;
        },
        setFilterParamsOrder(state, action) {
            if (
                Array.isArray(action.payload) &&
                !action.payload.some(val => typeof val !== 'string')
            ) {
                state.filterParamsOrder = action.payload;
            }
        },
        setParamsFilterQuery: (state, action) => {
            state.params_filter_query = action.payload;
        }
    },
    extraReducers: {}
});

export const { setParamsFilterQuery, setFilterParams, resetFilterState, setQueryFilter, addQueryFilter, setQueryToManual , restoreFilter, setLogic,
    selectFilterParam,
    removeFilterParam,
    addFilterQuery,
    resetFilterQueries,
    setFilterParamsForWorkspace
} = filterSlice.actions

export default filterSlice.reducer
